import React, { useEffect, useState } from 'react';
import { RefreshCw } from 'lucide-react';
import { applyUpdate } from '../lib/registerSW';

const CHECK_MS = 3 * 60 * 1000;

// Detecta despliegues nuevos comparando el asset-manifest (hash del bundle).
// Al detectar cambio muestra un aviso fijo que recarga la app al tocarlo.
export const UpdatePrompt = () => {
  const [available, setAvailable] = useState(false);

  useEffect(() => {
    let baseline = null;
    let cancelled = false;
    const check = async () => {
      try {
        // Un SW nuevo "en espera" también cuenta como actualización disponible
        const reg = await navigator.serviceWorker?.getRegistration?.();
        if (reg?.waiting && !cancelled) { setAvailable(true); return; }
      } catch { /* noop */ }
      try {
        const r = await fetch('/asset-manifest.json', { cache: 'no-store' });
        if (!r.ok) return;
        const j = await r.json();
        const sig = JSON.stringify(j.files?.['main.js'] || j.entrypoints || j);
        if (baseline == null) { baseline = sig; return; }
        if (!cancelled && sig !== baseline) setAvailable(true);
      } catch { /* offline: reintenta en el próximo ciclo */ }
    };
    check();
    const t = setInterval(check, CHECK_MS);
    const onVis = () => { if (document.visibilityState === 'visible') check(); };
    document.addEventListener('visibilitychange', onVis);
    return () => { cancelled = true; clearInterval(t); document.removeEventListener('visibilitychange', onVis); };
  }, []);

  const refresh = async () => {
    try {
      if ('serviceWorker' in navigator) {
        const reg = await navigator.serviceWorker.getRegistration();
        try { await reg?.update(); } catch { /* noop */ }
        applyUpdate(reg);
        return;
      }
    } catch { /* noop */ }
    window.location.reload();
  };

  if (!available) return null;
  return (
    <button
      type="button"
      onClick={refresh}
      data-testid="update-banner"
      className="fixed bottom-24 left-1/2 -translate-x-1/2 z-[1200] flex items-center gap-2 px-4 py-2.5 rounded-full bg-[#0f1d6f] text-[#f8f6f1] text-[12.5px] font-medium shadow-lg shadow-black/20 active:scale-[0.98] transition-transform"
    >
      <RefreshCw size={13} className="animate-spin" style={{ animationDuration: '3s' }}/>
      Nueva versión disponible — toca para actualizar
    </button>
  );
};
